import { useState } from 'react';
import { storage } from '../firebase'; // Ensure this points to your main firebase file
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage';

const useStorage = () => {
    const [progress, setProgress] = useState(0);
    const [error, setError] = useState(null);
    const [url, setUrl] = useState(null);
    const [isUploading, setIsUploading] = useState(false);

    const uploadFile = async (file, path) => {
        setError(null);
        setIsUploading(true);
        setProgress(0);

        return new Promise((resolve, reject) => {
            const storageRef = ref(storage, path);
            const uploadTask = uploadBytesResumable(storageRef, file);

            uploadTask.on(
                'state_changed',
                (snapshot) => {
                    const percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    setProgress(percentage);
                },
                (err) => {
                    setError(err);
                    setIsUploading(false);
                    reject(err);
                },
                async () => {
                    const downloadUrl = await getDownloadURL(uploadTask.snapshot.ref);
                    setUrl(downloadUrl);
                    setIsUploading(false);
                    resolve(downloadUrl);
                }
            );
        });
    };

    const deleteFile = async (path) => {
        const storageRef = ref(storage, path);
        try {
            await deleteObject(storageRef);
        } catch (err) {
            console.warn("File not found or already deleted:", err);
        }
    };

    return { progress, url, error, isUploading, uploadFile, deleteFile };
};

export default useStorage;